import axios from 'axios';

// API基础URL - 使用Graph应用的API端点
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '/Graph/api';

/**
 * 获取Graph数据
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.pageSize - 每页数量
 * @returns {Promise}
 */
export const getGraphData = (params = {}) => {
    const { page = 1, pageSize = 10 } = params;
    return axios.post(`${API_BASE_URL}/getGraphsForAdmin/`, {
        page,
        pageSize
    });
};

/**
 * 获取Node数据
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.pageSize - 每页数量
 * @returns {Promise}
 */
export const getNodeData = (params = {}) => {
    const { page = 1, pageSize = 10 } = params;
    return axios.post(`${API_BASE_URL}/getNodesForAdmin/`, {
        page,
        pageSize
    });
};

/**
 * 删除Graph
 * @param {number} id - Graph ID
 * @returns {Promise}
 */
export const deleteGraph = (id) => {
    return axios.post(`${API_BASE_URL}/deleteGraphForAdmin/`, {
        id
    });
};

/**
 * 删除Node
 * @param {number} id - Node ID
 * @returns {Promise}
 */
export const deleteNode = (id) => {
    return axios.post(`${API_BASE_URL}/deleteNodeForAdmin/`, {
        id
    });
};

/**
 * 更新Graph
 * @param {Object} data - 更新数据，包含id字段
 * @returns {Promise}
 */
export const updateGraph = (data) => {
    return axios.post(`${API_BASE_URL}/updateGraphForAdmin/`, data);
};

/**
 * 更新Node
 * @param {Object} data - 更新数据，包含id字段
 * @returns {Promise}
 */
export const updateNode = (data) => {
    return axios.post(`${API_BASE_URL}/updateNodeForAdmin/`, data);
};

/**
 * 搜索Graph数据
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.pageSize - 每页数量
 * @param {string} params.query - 搜索关键词
 * @returns {Promise}
 */
export const searchGraphData = (params = {}) => {
    const { page = 1, pageSize = 10, query = '' } = params;
    return axios.post(`${API_BASE_URL}/searchGraphsForAdmin/`, {
        page,
        pageSize,
        query
    });
};

/**
 * 搜索Node数据
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.pageSize - 每页数量
 * @param {string} params.query - 搜索关键词
 * @returns {Promise}
 */
export const searchNodeData = (params = {}) => {
    const { page = 1, pageSize = 10, query = '' } = params;
    return axios.post(`${API_BASE_URL}/searchNodesForAdmin/`, {
        page,
        pageSize,
        query
    });
};

